export default __webpack_public_path__ + "static/media/02.fe272286.jpg";